var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1295_3757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 17,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0144043,
    y: -0.00012207,
    width: 16,
    height: 15.9995,
    transform: "rotate(0.0508045 0.0144043 -0.00012207)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1295_3757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33714 12.0043L10.6705 12.009L10.6717 10.6757L5.33832 10.671L5.33714 12.0043ZM5.3395 9.3377L10.6728 9.34243L10.674 8.00914L5.34069 8.00441L5.3395 9.3377ZM4.00144 14.6697C3.63478 14.6694 3.32111 14.5387 3.06046 14.2775C2.79935 14.016 2.66897 13.7019 2.66929 13.3352L2.67875 2.66887C2.67907 2.30221 2.81002 1.98833 3.07158 1.72724C3.3327 1.46659 3.6466 1.33643 4.01326 1.33675L9.3466 1.34148L13.343 5.34491L13.336 13.3447C13.3356 13.7113 13.2049 14.0252 12.9438 14.2863C12.6822 14.547 12.3681 14.6771 12.0014 14.6768L4.00144 14.6697ZM8.67579 6.00742L12.0091 6.01038L8.67875 2.67419L8.67579 6.00742Z",
    fill: "#595959"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionNote);
export default __webpack_public_path__ + "static/media/mission-note.bb6362be0ddffeb2961c7f36e5df76a1.svg";
export { ForwardRef as ReactComponent };